/**
 * Shared PlanTierField Component
 * Displays plan tier as a color-coded outlined Chip
 * Used in UserList, BonusUsageList, and similar views
 */

import { useRecordContext } from 'react-admin';
import { Chip } from '@mui/material';
import { PLAN_TIER_LABELS, PLAN_TIER_CHIP_COLORS } from '../../constants';

export function PlanTierField({ label: _label }: { label?: string } = {}) {
  const record = useRecordContext();
  if (!record?.planTier) return null;

  const tier = record.planTier.toLowerCase();
  const color = PLAN_TIER_CHIP_COLORS[tier] || 'default';

  return (
    <Chip
      label={PLAN_TIER_LABELS[tier] || record.planTier}
      color={color}
      size="small"
      variant="outlined"
    />
  );
}
